<template>
    <div class="d-flex align-center">
        <div><v-icon v-if="icon !== ''" :class="iconclass">{{ icon }}</v-icon></div>
        <div :class="dynamicClass"><slot></slot></div>
    </div>
</template>

<script>
export default {
    props: {
        category: {
            type: String,
            default: '', 
            required: false
        },
        icon: {
            type: String,
            default: '',
            required: false
        },
        iconclass: {
            type: String,
            default: '',
            required: false
        },
        vhtml: {
            type: String,
            default: '',
            required: false
        }
    },
    computed: {
        dynamicClass: function() {
            switch (this.category) {
                case 'content-title':
                    return 'content-title secondary--text'
                    break;
                case 'content-help':
                    return 'content-help primary--text'
                    break;
                case 'tab-title':
                    return 'tab-title grey--text text--darken-3'
                    break;
                case 'tab-text':
                    return 'tab-text grey--text text--darken-3'
                    break;
                case 'popup-title':
                    return 'popup-title white--text'
                    break;
                case 'popup-text':
                    return 'popup-text grey--text text--darken-3'
                    break;
                case 'dialog-title':
                    return 'dialog-title white--text'
                    break;
				case 'text-default-bold':
					return 'text-default-bold'
					break;
                case 'text-medium':
                    return 'text-medium'
                    break;
                case 'text-medium-bold':
                    return 'text-medium-bold'
                    break;
                default:
                    return this.category;
                    break;
            }
        }
    }
}
</script>

<style lang="sass">
  @import '~vuetify/src/styles/styles.sass'

  @media #{map-get($display-breakpoints, 'md-and-up')}
    .content-help
        font-size: 18px   
        font-weight: thin 
    
    .tab-title
        font-size: 16px   
        font-weight: bold  
    
    .tab-text
        font-size: 16px   
        font-weight: normal  
    
    .text-default-bold
        font-size: 16px
        font-weight: bold
    
    .text-medium
        font-size: 20px

    .text-medium-bold
        font-size: 20px
        font-weight: bold

    .popup-title
        font-size: 16px   
        font-weight: normal  
    
    .popup-text
        font-size: 16px   
        font-weight: normal  
    
    .content-help
        font-size: 18px   
        font-weight: thin  
    
    .dialog-title
        font-size: 18px   
        font-weight: thin  

    .content-title
        font-size: 20px
        max-width: 400px

    .help-text
        font-size: 15px

    .auth-description
        font-size: 20px

    .auth-label
        font-size: 18px
        font-weight: bold

  @media #{map-get($display-breakpoints, 'xs-only')}
    .content-title
        font-size: 20px
        max-width: 200px

    .auth-description
        font-size: 15px

    .auth-label
        font-size: 15px
        font-weight: bold

    .auth-label-description
        font-size: 13px
</style>

